import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Button, Divider, Grid, IconButton, Typography } from 'src/components';
import Card from 'src/components/Card';
import CardActions from 'src/components/CardActions';
import CardContent from 'src/components/CardContent';
import Editor from 'src/components/Editor';
import Paper from 'src/components/Paper';
import DokumanEkranTipleri from 'src/parts/Dokuman/DokumanEnum';
import DokumanYukle from 'src/parts/Dokuman/DokumanYukle';
import { useAppDispatch, useAppSelector } from 'src/store';
import { helper } from 'src/utils/helper';

interface IDuyuruDetay {
    setOku: (value: boolean) => void;
    height?: string;
    loginControl?: boolean;
}

const DuyuruDetay = (props: IDuyuruDetay) => {
    const { t } = useTranslation();
    const rl = "pages|duyuru|duyuruDetay|"
    const duyuruActiveRow = useAppSelector((state) => state.DuyuruTanimState.duyuruActiveRow);
    const dispatch = useAppDispatch();
    const [dokumanOpen, setDokumanOpen] = useState<boolean>(false);

    const handleBackClick = () => {
        props.setOku(false);
    }
    return (
        <Grid container>
            <Grid item>
                <Paper>
                    <Grid container>
                        <Grid item  >
                            <Typography
                                sx={{ fontSize: 14 }}
                                color="text.secondary"
                                gutterBottom
                            >
                                {t(rl + 'yayinlamaTarih', 'Yayınlanma Tarihi:')} {helper.jsonToShortDateString(duyuruActiveRow.gonderimtarihi)}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography
                                sx={{ mb: 1.5 }}
                                color="text.secondary"
                            >
                                <Divider />
                            </Typography>

                        </Grid>

                        <Grid item>
                            <Editor
                                label={t(rl + 'icerik', 'İçerik')}
                                height={'680px'}
                                defaultValue={duyuruActiveRow.belgeicerikStr}
                                value={duyuruActiveRow.belgeicerikStr}
                                readOnly
                            />
                        </Grid>

                        <Grid item md={4} lg={2} xl={2} sx={{ marginTop: 5 }}>
                            <Button
                                customType="back"
                                onClick={handleBackClick}
                            >
                                {t(rl + 'geri', 'Geri')}
                            </Button>
                        </Grid>

                        <Grid item md={4} lg={8} xl={8}></Grid>

                        <Grid item md={4} lg={2} xl={2} sx={{ marginTop: 5 }}>
                            {!props.loginControl && (
                                <Button customType='document'
                                    onClick={(e) => {
                                        setDokumanOpen(true)
                                        // setActiveRowId(params.row.pkMesaj);
                                    }} />
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            {dokumanOpen &&
                <DokumanYukle
                    dialogMode={true}
                    open={dokumanOpen}
                    onClose={() => { setDokumanOpen(false); }}
                    fullWidth={true}
                    maxWidth="md"
                    height={600}
                    tip={DokumanEkranTipleri.duyuru}
                    alanId={duyuruActiveRow.id}
                />
            }
        </Grid>
    )
}

export default DuyuruDetay;